import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircledCheckmark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M16.9997 33.6666C26.2043 33.6666 33.6663 26.2046 33.6663 17C33.6663 7.79523 26.2043 0.333313 16.9997 0.333313C7.79492 0.333313 0.333008 7.79523 0.333008 17C0.333008 26.2046 7.79492 33.6666 16.9997 33.6666ZM26.0948 12.7618L15.333 23.5236L8.32116 16.5118L10.6782 14.1548L15.333 18.8096L23.7378 10.4048L26.0948 12.7618Z" })]
});
const ForwardRef = forwardRef(SvgCircledCheckmark);
export { ForwardRef as ReactComponent };
